interface PaidSlotCardProps {
  readonly assigned: number;
  readonly total: number;
  readonly label: string;
  readonly note: string;
}

export function PaidSlotCard({ assigned, total, label, note }: PaidSlotCardProps) {
  return (
    <article className="admin-panel paid-slot-card">
      <div className="paid-slot-card-header">
        <h2>Paid slot usage</h2>
        <span className={assigned > 0 ? "status-chip success" : "status-chip quiet"}>
          {assigned > 0 ? "Assigned" : "Available"}
        </span>
      </div>
      <strong>{assigned}/{total}</strong>
      <p>{label}</p>
      <span>{note}</span>
    </article>
  );
}
